<vi-text size="medium">
  {{ '+INSTALLATIONS.INSTALLATION.MAINTENANCE_CHECKLIST.MESSAGE' | translate }}
</vi-text>
<div class="pdf-preview-container flex flex-col">
  <ng-container
    *ngIf="
      installationDetailsStore.maintenanceChecklistStatus$ | async as maintenanceChecklistStatus
    "
  >
    <!-- Loading -->
    <ng-container *ngIf="maintenanceChecklistStatus.loading; else fetchCompleted">
      <vi-loader data-at-loader-booking [isLoading]="true"></vi-loader>
    </ng-container>

    <ng-template #fetchCompleted>
      <!-- Loaded & data -->
      <ng-container
        *ngIf="maintenanceChecklistStatus.loaded && maintenanceChecklistItem$ | async as checklist"
      >
        <ng-container *ngIf="checklist?.length > 0; else noMaintenanceChecklist">
          <app-pdf-preview
            [src]="checklist[0]?.url"
            [originalSize]="false"
            [zoom]="0"
            [showAll]="false"
            [page]="2"
            [showBorders]="true"
            [autoresize]="true"
            [allowNavigation]="false"
            [allowZoomScale]="true"
            [allowDownload]="true"
            gtmAction="Maintenance checklist"
            gtmCategory="installationDetailsMenu"
          ></app-pdf-preview>
        </ng-container>
      </ng-container>

      <!-- Error -->
      <ng-container *ngIf="maintenanceChecklistStatus.error">
        <ng-container *ngTemplateOutlet="noMaintenanceChecklist"></ng-container>
      </ng-container>
    </ng-template>
  </ng-container>

  <!-- TODO: Temporary solution. Waiting for designs -->
  <ng-template #noMaintenanceChecklist
    ><div data-at-no-checklist-available class="flex flex-row justify-center items-center">
      {{ '+MAINTENANCE_CHECKLIST.NO_CHECKLIST' | translate }}
    </div></ng-template
  >
</div>
